import { Link } from "react-router-dom";

const sectionLinkClassName =
  "font-medium text-blue-600 hover:text-blue-800 hover:underline";

const PdfGeneratorInstructions = () => (
  <p className="mb-6 rounded border border-gray-200 bg-gray-50 px-4 py-3 text-sm text-gray-600">
    To create a PDF document, select{" "}
    <Link className={sectionLinkClassName} to="/instance">
      Instances
    </Link>
    ,{" "}
    <Link className={sectionLinkClassName} to="/artworks">
      Artworks
    </Link>{" "}
    or{" "}
    <Link className={sectionLinkClassName} to="/exhibition">
      Exhibitions
    </Link>{" "}
    from their respective sections, then choose{" "}
    <span className="font-medium text-gray-900">
      Actions &gt; PDF Generator
    </span>
    .
  </p>
);

export default PdfGeneratorInstructions;
